import { Injectable } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from "@angular/forms";
import { UnidadeService } from "../unidade.service";
import { Observable } from "rxjs";
import { AbStep } from "app/abstract/full-pages/unidade/step.abstract";

@Injectable({ providedIn: 'root' })
export class StepService extends AbStep {
    unidadeForm: UntypedFormGroup = new UntypedFormGroup({ invalid: new UntypedFormControl(undefined, Validators.required) });
    blocoForm: UntypedFormGroup = new UntypedFormGroup({ invalid: new UntypedFormControl(undefined, Validators.required) });

    blocoLazy: boolean = true;
    configBlocoLazy: boolean = false;

    public blocoCompleted: boolean = true;
    public configBlocoCompleted: boolean = false;

    tipoConta: any;

    constructor(public unidadeService: UnidadeService) {
        super()
    }

    static valorAcimaDeZero(AC: AbstractControl) {
        let errorStr: String = new String(AC.value);

        if (AC && (AC.value == 0 && errorStr.trim() != "")) {
            return { 'MaiorQueZero': { value: AC.value } };
        }
        return null;
    }

    public getBlocoCompleted(): boolean {
        return this.blocoCompleted;
    }

    public getConfigBlocoCompleted(): boolean {
        return this.configBlocoCompleted;
    }

    public setBlocoCompleted(completed: boolean): Observable<any> {
        this.blocoCompleted = completed;
        return this.observableCompleted();
    }

    public setConfigBlocoCompleted(completed: boolean): Observable<any> {
        this.configBlocoCompleted = completed;
        return this.observableCompleted();
    }

    public observableCompleted(): Observable<boolean> {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next(true);
                observer.complete();
            }, 100);
        })
    }
}
